import { BaseEntity } from './base-entity';
import { AssessmentSummary } from './assessment-summary';

export class GetRiskAssessmentSummaryResponse extends BaseEntity {
  riskSummaries: Array<AssessmentSummary>;
  canMarkComplete: boolean;
}
